import { render, staticRenderFns } from "./InformedConsentNew.vue?vue&type=template&id=8af1755c&"
import script from "./InformedConsentNew.vue?vue&type=script&lang=js&"
export * from "./InformedConsentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports